import { Outlet,Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoutes = () => {
     const user = useSelector((state) => state.auth.isAuthenticated);
     return user ? <Outlet /> : <Navigate to="/login?Redirect" />
}

export default ProtectedRoutes;